import { render, staticRenderFns } from "./TipoVehiculo.vue?vue&type=template&id=7979b71a&"
import script from "./TipoVehiculo.vue?vue&type=script&lang=ts&"
export * from "./TipoVehiculo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7979b71a', component.options)
    } else {
      api.reload('7979b71a', component.options)
    }
    module.hot.accept("./TipoVehiculo.vue?vue&type=template&id=7979b71a&", function () {
      api.rerender('7979b71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/TipoVehiculo.vue"
export default component.exports